exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{\r\n    width: 100%;\r\n}\r\n\r\n.main-wrp, buffer-graph{\r\n    width: 100%;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/buffer-graph/components/buffer-graph-outer-layer.component/buffer-graph-outer-layer.component.css
// module id = ./src/app/buffer-graph/components/buffer-graph-outer-layer.component/buffer-graph-outer-layer.component.css
// module chunks = main